var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectTableDialog',{attrs:{"title":_vm.$t('logistics.returnOrderTable.Title'),"searchColumns":_vm.searchColumns,"columnList":_vm.columnList,"defaultVisible":_vm.defaultVisible,"API":_vm.API,"extraData":_vm.extraData,"confirmUnchecked":false,"isMultiple":false,"width":"1200px"},on:{"close":_vm.close,"confirm":_vm.creatOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }